<template>
  <div class="container">
    <div v-for="doctype in doctypes" class="panel">
      <div class="col-7 col-md-12">
        <div class="panel-header">      
          <div class="panel-title h5">{{doctype.name}}</div>
           <div v-if="doctype.helptext" class="tooltipz" v-html="doctype.helptext"></div> 
           <!-- spectre tooltips 
          <button v-if="doctype.helptext" class="btn btn-link tooltip tooltip-right" :data-tooltip="doctype.helptext">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
          </button>
          -->
          <upload :matter="matter" :doctype="doctype" v-on:new="addFile"></upload>
        </div>
        <div class="panel-body">
          <file-item v-for="(file, index) in files[doctype.ref]"
                   v-on:deleted="delFile(doctype.ref, index)"
                   :key="file.id"
                   :file="file"
                   :matter="matter"></file-item>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import fileItem from '@/components/documents/fileItem'
import upload from '@/components/documents/upload'

export default {
  name: 'matterDocs',
  components: {
    'upload': upload,
    'file-item': fileItem
  },
  props: ['matterdata'],
  data () {
    return {
      files: {},
      matter: null,
      doctypes: null,
      saving: false,
      error: ''
    }
  },
  created () {
    this.matter = this.matterdata.matter

    // Filter doctypes with met dependencies
    var ans
    let answers = this.$root.$data.client.answers
    this.doctypes = this.matterdata.visatype.doctypes.filter(dt => {
      if (!dt.dependent) return true
      if (!dt.depends.ref) return false
      if (!answers[dt.depends.ref]) return false
      for (ans of answers[dt.depends.ref]) {
        if (ans.ref === dt.depends.ref && ans.atxt === dt.depends.atxt) {
          return true
        }
      }
      return false
    })

    // Create a list for every doctype in the matter
    this.doctypes.forEach(t => {
      this.files[t.ref] = []
    })

    // Split the files according to their doctype
    this.matter.files.forEach(f => {
      if (this.files.hasOwnProperty(f.docref)) {
        this.files[f.docref].push(f)
      }
    })
  },
  methods: {
    addFile (file) {
      if (!this.files[file.docref]) {
        this.files[file.docref] = [file]
      } else {
        this.files[file.docref].splice(this.files[file.docref].length, 0, file)
      }
      this.$forceUpdate()
    },
    delFile (ref, index) {
      this.files[ref].splice(index, 1)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.panel {
  margin-top: 10px;
}
label.myLabel input[type="file"] {
  position: fixed;
  top: -1000px;
}
.tooltipz {
  margin: 1em 0 0 0;
}
</style>



// WEBPACK FOOTER //
// matterDocs.vue?150a5ad5